// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "content-o5WAg";
var _3 = "text-38zKS";
var _4 = "button-dnXCl";
var _5 = "button_cancel-3D3ns";
export { _1 as "__esModule", _2 as "content", _3 as "text", _4 as "button", _5 as "button_cancel" }
export default { "__esModule": _1, "content": _2, "text": _3, "button": _4, "button_cancel": _5 }
